<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <!-- <Banner
        :background="info.image ? info.image.url : ''"
        :title="!pgLoading ? $t('app.videos') : ''"
        :subtitle="!pgLoading ? $t('app.videos') : ''"
      >
      </Banner> -->

    <section class="video-gallery-area pt-20 pb-50">
      <div v-if="rows.length > 0" class="custom-container">
        <div v-if="!pgLoading" class="row">
          <div class="col-xl-12">
            <div
              class="section-title text-center mb-3 pl-50 pr-50 wow fadeInUp2 animated"
              data-wow-delay=".1s"
              :style="locale == 'en' ? 'text-align: left !important' : ''"
            >
              <h6>
                <span>
                  <i class="fas fa-hand-holding-seedling"></i>
                </span>
                {{ $t("app.our_thumbs") }}
              </h6>
              <!-- <h2>{{ info.title }}</h2> -->
            </div>
          </div>
        </div>

        <div
          class="gallery-video pt-100 pb-70"
          :class="locale == 'ar' ? 'rtl' : 'ltr'"
          style="display: none"
        >
          <div v-if="pgLoading" class="section-title webkit-ml20per">
            <div class="webkit-animation webkit-100-240"></div>
          </div>
          <div v-if="!pgLoading" class="section-title">
            <span>
              <i class="bx bx-video"></i>
              {{ $t("multimedia.title") }}
            </span>
            <h2 class="font-deco mb-3">
              {{ info.title }}
            </h2>
            <p v-html="info.body"></p>
          </div>
        </div>

        <div v-if="pgLoading" class="row">
          <div
            class="col-xl-4 col-lg-3 col-md-6"
            v-for="(row, index) in 8"
            :key="index"
          >
            <div
              class="gallery gallery-02 pos-rel text-center wow fadeInUp2 animated"
              data-wow-delay=".3s"
              style="
                visibility: visible;
                animation-delay: 0.3s;
                animation-name: fadeInUp2;
              "
            >
              <div class="gallery__thumb pos-rel mb-30"></div>
              <div class="video-area"></div>
            </div>
          </div>
        </div>

        <div v-if="!pgLoading" class="row g-2">
          <div
            class="col-xl-4 col-lg-3 col-md-6 p-2"
            v-for="(row, index) in rows"
            :key="index"
          >
            <div
              class="gallery gallery-02 pos-rel text-center wow fadeInUp2 animated"
              data-wow-delay=".3s"
              style="
                visibility: visible;
                animation-delay: 0.3s;
                animation-name: fadeInUp2;
              "
            >
              <div class="gallery__thumb pos-rel mb-30" style="border-radius: 25px;">
                <img
                  v-if="row.thumb"
                  :src="row.thumb"
                  loading="lazy"
                  :alt="row.caption"
                  style="height: 255px"
                />
                <img
                  v-if="!row.thumb"
                  loading="lazy"
                  src="/assets/img/logo/min-logo.png"
                  style="height: 255px"
                />
              </div>
              <div class="video-area">
                <a
                  href="javascript:;"
                  @click="openVideo(row.src)"
                  class="popup-video"
                  style="line-height: 91px !important"
                >
                  <i class="fas fa-play" style="margin-right: -5px"> </i>
                </a>
              </div>
              <!-- <h5 style="width: 100%; margin-top: -15px">{{ row.caption }}</h5> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- magnific popup -->
    <div v-if="magnific_popup" class="position-relative">
      <div
        class="mfp-bg mfp-fade mfp-ready"
        style="height: 2142px; position: fixed"
      ></div>

      <div
        class="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-fade mfp-ready"
        tabindex="-1"
        style="top: 550px; position: absolute; height: 437px"
      >
        <div class="mfp-container mfp-iframe-holder" style="position: fixed">
          <div class="mfp-content">
            <div class="mfp-iframe-scaler">
              <button
                title="Close (Esc)"
                type="button"
                @click="closeMagnific()"
                class="mfp-close"
              >
                ×
              </button>

              <div class="outside" @click="closeMagnific()"></div>
              <iframe
                class="mfp-iframe"
                :src="
                  `https://www.youtube.com/embed/${this.video_url}` +
                  '?autoplay=1'
                "
                frameborder="0"
                allowfullscreen=""
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <Pagination
      v-if="!pgLoading"
      :currentPage="paginate.currentPage"
      :itemsPerPage="paginate.itemsPerPage"
      :resultCount="paginate.resultCount"
      :nextPage="paginate.nextPage"
      :prevPage="paginate.prevPage"
      v-on:pageChange="handlePageChange"
    >
    </Pagination>
    <!-- End Pagination -->
  </div>
</template>
  
  <script>
// import iziToast from "izitoast";

export default {
  name: "videos",
  components: {
    // Banner: () => import("@/components/Banner.vue"),
    Pagination: () => import("@/components/Pagination.vue"),
  },
  data() {
    return {
      locale: "ar",
      pgLoading: true,
      info: "",
      rows: [],

      paginate: {
        currentPage: 1,
        itemsPerPage: 12,
        resultCount: 0,
        nextPage: 2,
        prevPage: 0,
      },

      magnific_popup: false,
      video_url: "",
    };
  },
  mounted() {},
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/thumbnail",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: this.paginate.itemsPerPage,
          page: this.paginate.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;

          // info
          this.info = res.data.info;

          // paginate
          this.paginate.currentPage = res.data.paginate.current_page;
          this.paginate.resultCount = res.data.paginate.total;
          this.paginate.nextPage = res.data.paginate.next_page;
          this.paginate.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => {})
        .finally(() => {});
    },

    handlePageChange(event) {
      this.paginate.currentPage = event.currentPage;
      this.fetchData();
    },

    openVideo: function (path) {
      this.magnific_popup = true;
      let videoId = path.slice(17);
      this.video_url = videoId;
    },

    closeMagnific: function () {
      this.magnific_popup = false;
      this.video_url = "";
    },
  },
};
</script>
  
  <style scoped>
.outside {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
}
.custom-container {
  width: 90%;
}
</style>